module.exports = __webpack_public_path__ + "static/media/alis11.de56e839.jpg";